<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    class="fill-current inline-block"
    :class="[width, height]"
    viewBox="0 0 31.861 30.451"
  >
    <defs>
      <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
        <stop offset="0" stop-color="#de4551" stop-opacity="0" />
        <stop offset="1" stop-color="#de4551" />
      </linearGradient>
    </defs>
    <g id="Group_155" data-name="Group 155" transform="translate(-572.86 28.339)">
      <path
        id="Path_769"
        data-name="Path 769"
        d="M601.452,75.574H583.068V73.836a.7.7,0,0,0-.7-.7h-5.48a.7.7,0,0,0-.7.7v1.737h-1.845a1.476,1.476,0,0,0-1.477,1.477V93.533a1.476,1.476,0,0,0,1.477,1.477H592.63v1.533a.7.7,0,0,0,.7.7h5.48a.7.7,0,0,0,.7-.7V95.009h1.935a1.476,1.476,0,0,0,1.477-1.477V77.05a1.476,1.476,0,0,0-1.477-1.477Z"
        transform="translate(0 -97.263)"
        opacity="0.1"
        fill="url(#linear-gradient)"
        style="isolation: isolate"
      />
      <path
        id="Path_770"
        data-name="Path 770"
        d="M623.421,87.781v16.483a1.476,1.476,0,0,1-1.477,1.477H594.829a1.476,1.476,0,0,1-1.477-1.477V87.781a1.476,1.476,0,0,1,1.477-1.477h27.116A1.476,1.476,0,0,1,623.421,87.781Z"
        transform="translate(-19.051 -109.508)"
        fill="#fff"
      />
      <path
        id="Path_771"
        data-name="Path 771"
        d="M941.012,230.793h5.3v-2.628h-5.3a.352.352,0,0,0-.352.352v1.925A.352.352,0,0,0,941.012,230.793Z"
        transform="translate(-341.939 -241.394)"
        fill="#f0324c"
      />
      <path
        id="Path_772"
        data-name="Path 772"
        d="M593.352,138.514h30.069v4.75H593.352Z"
        transform="translate(-19.051 -158.047)"
        fill="#f0324c"
      />
      <path
        id="Path_773"
        data-name="Path 773"
        d="M646.777,58.482H641.3a.7.7,0,0,1-.7-.7V52.3a.7.7,0,0,1,.7-.7h5.48a.7.7,0,0,1,.7.7v5.48A.7.7,0,0,1,646.777,58.482Z"
        transform="translate(-62.971 -77.239)"
        fill="#f0324c"
      />
      <path
        id="Path_774"
        data-name="Path 774"
        d="M880.707,303.474h-5.48a.7.7,0,0,1-.7-.7v-5.48a.7.7,0,0,1,.7-.7h5.48a.7.7,0,0,1,.7.7v5.48A.7.7,0,0,1,880.707,303.474Z"
        transform="translate(-280.452 -305.005)"
        fill="#f0324c"
      />
      <g id="Group_153" data-name="Group 153" transform="translate(573.949 -25.996)">
        <path
          id="Path_775"
          data-name="Path 775"
          d="M623,283.915h-1.162a.352.352,0,0,1,0-.7H623a.352.352,0,0,1,0,.7Z"
          transform="translate(-619.154 -266.575)"
          fill="#2f3042"
        />
        <path
          id="Path_776"
          data-name="Path 776"
          d="M631.487,309.915h-9.653a.352.352,0,0,1,0-.7h9.653a.352.352,0,0,1,0,.7Z"
          transform="translate(-619.154 -290.747)"
          fill="#2f3042"
        />
        <path
          id="Path_777"
          data-name="Path 777"
          d="M631.487,329h-9.653a.352.352,0,0,1,0-.7h9.653a.352.352,0,0,1,0,.7Z"
          transform="translate(-619.154 -308.485)"
          fill="#2f3042"
        />
        <circle
          id="Ellipse_243"
          data-name="Ellipse 243"
          cx="0.393"
          cy="0.393"
          r="0.393"
          transform="translate(19.837 8.445)"
          fill="#2f3042"
        />
        <circle
          id="Ellipse_244"
          data-name="Ellipse 244"
          cx="0.393"
          cy="0.393"
          r="0.393"
          transform="translate(21.026 8.445)"
          fill="#2f3042"
        />
        <circle
          id="Ellipse_245"
          data-name="Ellipse 245"
          cx="0.393"
          cy="0.393"
          r="0.393"
          transform="translate(22.215 8.445)"
          fill="#2f3042"
        />
        <path
          id="Path_778"
          data-name="Path 778"
          d="M617.3,49.035H599.265V47.65a1.056,1.056,0,0,0-1.055-1.055h-5.48a1.056,1.056,0,0,0-1.055,1.055v1.386h-1.493a1.83,1.83,0,0,0-1.828,1.828V63.813a.352.352,0,0,0,.7,0V58.16h29.365v9.187a1.126,1.126,0,0,1-1.125,1.125h-1.584v-3.6a1.056,1.056,0,0,0-1.055-1.055h-5.481a1.056,1.056,0,0,0-1.055,1.055v3.6H590.182a1.126,1.126,0,0,1-1.125-1.125V65.788a.352.352,0,0,0-.7,0v1.558a1.83,1.83,0,0,0,1.828,1.828h17.942v1.182a1.056,1.056,0,0,0,1.055,1.055h5.48a1.056,1.056,0,0,0,1.055-1.055V69.175H617.3a1.83,1.83,0,0,0,1.828-1.828V50.863a1.83,1.83,0,0,0-1.828-1.828Zm-2.287,21.321a.352.352,0,0,1-.352.352h-5.48a.352.352,0,0,1-.352-.352v-5.48a.352.352,0,0,1,.352-.352h5.48a.352.352,0,0,1,.352.352ZM592.379,47.65a.352.352,0,0,1,.352-.352h5.48a.352.352,0,0,1,.352.352v5.48a.352.352,0,0,1-.352.352h-5.48a.352.352,0,0,1-.352-.352Zm-2.2,2.089h1.493v2.968h-2.618V50.863A1.126,1.126,0,0,1,590.182,49.738Zm-1.125,7.718V53.41h2.657a1.056,1.056,0,0,0,1.016.775h5.48a1.056,1.056,0,0,0,1.055-1.055V49.738H617.3a1.126,1.126,0,0,1,1.125,1.125v1.843H601.039a.352.352,0,0,0,0,.7h17.383v4.047Z"
          transform="translate(-588.354 -46.595)"
          fill="#2f3042"
        />
        <path
          id="Path_779"
          data-name="Path 779"
          d="M894.234,317.213a.915.915,0,1,1,.915-.915A.916.916,0,0,1,894.234,317.213Zm0-1.126a.212.212,0,1,0,.212.212A.212.212,0,0,0,894.234,316.086Z"
          transform="translate(-871.876 -296.484)"
          fill="#2f3042"
        />
        <path
          id="Path_780"
          data-name="Path 780"
          d="M928.563,351.543a.915.915,0,1,1,.915-.915A.916.916,0,0,1,928.563,351.543Zm0-1.127a.212.212,0,1,0,.212.212A.212.212,0,0,0,928.563,350.416Z"
          transform="translate(-903.791 -328.4)"
          fill="#2f3042"
        />
        <path
          id="Path_781"
          data-name="Path 781"
          d="M904.654,329.066a.352.352,0,0,1-.249-.6l2-2a.352.352,0,0,1,.5.5l-2,2A.35.35,0,0,1,904.654,329.066Z"
          transform="translate(-882.087 -306.695)"
          fill="#2f3042"
        />
        <g id="Group_152" data-name="Group 152" transform="translate(2.35 12.694)">
          <path
            id="Path_782"
            data-name="Path 782"
            d="M622.985,229.949h-.375a.831.831,0,0,1-.83-.83v-1.157a.831.831,0,0,1,.83-.83h.375a.831.831,0,0,1,.83.83v1.157A.831.831,0,0,1,622.985,229.949Zm-.375-2.114a.127.127,0,0,0-.127.127v1.157a.127.127,0,0,0,.127.127h.375a.127.127,0,0,0,.127-.127v-1.157a.127.127,0,0,0-.127-.127Z"
            transform="translate(-621.78 -227.132)"
            fill="#2f3042"
          />
          <path
            id="Path_783"
            data-name="Path 783"
            d="M658.33,228.746h-.986a.352.352,0,0,1-.352-.352v-.91a.352.352,0,1,1,.7,0v.558h.635a.352.352,0,0,1,0,.7Z"
            transform="translate(-654.516 -227.133)"
            fill="#2f3042"
          />
          <path
            id="Path_784"
            data-name="Path 784"
            d="M672.966,229.907a.352.352,0,0,1-.352-.352v-2.07a.352.352,0,1,1,.7,0v2.07A.352.352,0,0,1,672.966,229.907Z"
            transform="translate(-669.04 -227.133)"
            fill="#2f3042"
          />
          <path
            id="Path_785"
            data-name="Path 785"
            d="M691.329,229.949h-.375a.831.831,0,0,1-.83-.83v-1.157a.831.831,0,0,1,.83-.83h.375a.831.831,0,0,1,.83.83v1.157A.831.831,0,0,1,691.329,229.949Zm-.375-2.114a.127.127,0,0,0-.127.127v1.157a.127.127,0,0,0,.127.127h.375a.127.127,0,0,0,.127-.127v-1.157a.127.127,0,0,0-.127-.127Z"
            transform="translate(-685.319 -227.132)"
            fill="#2f3042"
          />
          <path
            id="Path_786"
            data-name="Path 786"
            d="M726.673,228.746h-.986a.352.352,0,0,1-.352-.352v-.91a.352.352,0,1,1,.7,0v.558h.635a.352.352,0,0,1,0,.7Z"
            transform="translate(-718.054 -227.133)"
            fill="#2f3042"
          />
          <path
            id="Path_787"
            data-name="Path 787"
            d="M741.31,229.907a.352.352,0,0,1-.352-.352v-2.07a.352.352,0,1,1,.7,0v2.07A.352.352,0,0,1,741.31,229.907Z"
            transform="translate(-732.578 -227.133)"
            fill="#2f3042"
          />
          <path
            id="Path_788"
            data-name="Path 788"
            d="M786.018,228.746h-.986a.352.352,0,0,1-.352-.352v-.91a.352.352,0,1,1,.7,0v.558h.635a.352.352,0,0,1,0,.7Z"
            transform="translate(-773.226 -227.133)"
            fill="#2f3042"
          />
          <path
            id="Path_789"
            data-name="Path 789"
            d="M800.655,229.907a.352.352,0,0,1-.352-.352v-2.07a.352.352,0,1,1,.7,0v2.07A.352.352,0,0,1,800.655,229.907Z"
            transform="translate(-787.75 -227.133)"
            fill="#2f3042"
          />
          <path
            id="Path_790"
            data-name="Path 790"
            d="M819.126,228.746h-.986a.352.352,0,0,1-.352-.352v-.91a.352.352,0,1,1,.7,0v.558h.634a.352.352,0,1,1,0,.7Z"
            transform="translate(-804.006 -227.133)"
            fill="#2f3042"
          />
          <path
            id="Path_791"
            data-name="Path 791"
            d="M833.761,229.907a.352.352,0,0,1-.352-.352v-2.07a.352.352,0,1,1,.7,0v2.07A.352.352,0,0,1,833.761,229.907Z"
            transform="translate(-818.529 -227.133)"
            fill="#2f3042"
          />
          <path
            id="Path_792"
            data-name="Path 792"
            d="M852.232,228.746h-.986a.352.352,0,0,1-.352-.352v-.91a.352.352,0,1,1,.7,0v.558h.635a.352.352,0,0,1,0,.7Z"
            transform="translate(-834.784 -227.133)"
            fill="#2f3042"
          />
          <path
            id="Path_793"
            data-name="Path 793"
            d="M866.869,229.907a.352.352,0,0,1-.352-.352v-2.07a.352.352,0,1,1,.7,0v2.07A.352.352,0,0,1,866.869,229.907Z"
            transform="translate(-849.309 -227.133)"
            fill="#2f3042"
          />
          <path
            id="Path_794"
            data-name="Path 794"
            d="M885.34,228.746h-.986a.352.352,0,0,1-.352-.352v-.91a.352.352,0,1,1,.7,0v.558h.635a.352.352,0,0,1,0,.7Z"
            transform="translate(-865.564 -227.133)"
            fill="#2f3042"
          />
          <path
            id="Path_795"
            data-name="Path 795"
            d="M899.976,229.907a.352.352,0,0,1-.352-.352v-2.07a.352.352,0,1,1,.7,0v2.07A.352.352,0,0,1,899.976,229.907Z"
            transform="translate(-880.088 -227.133)"
            fill="#2f3042"
          />
        </g>
      </g>
      <path
        id="Path_796"
        data-name="Path 796"
        d="M751.678,13.844h-.229v-.229a.352.352,0,0,0-.7,0v.229h-.229a.352.352,0,0,0,0,.7h.229v.229a.352.352,0,0,0,.7,0v-.229h.229a.352.352,0,0,0,0-.7Z"
        transform="translate(-164.839 -41.603)"
        fill="#f0324c"
      />
      <path
        id="Path_797"
        data-name="Path 797"
        d="M978.476,409.844h-.229v-.229a.352.352,0,0,0-.7,0v.229h-.229a.352.352,0,0,0,0,.7h.229v.229a.352.352,0,0,0,.7,0v-.229h.229a.352.352,0,0,0,0-.7Z"
        transform="translate(-375.69 -409.759)"
        fill="#f0324c"
      />
      <path
        id="Path_798"
        data-name="Path 798"
        d="M736.306,399.584h-.229v-.229a.352.352,0,0,0-.7,0v.229h-.229a.352.352,0,0,0,0,.7h.229v.229a.352.352,0,0,0,.7,0v-.229h.229a.352.352,0,0,0,0-.7Z"
        transform="translate(-150.548 -400.221)"
        fill="#f0324c"
      />
      <path
        id="Path_799"
        data-name="Path 799"
        d="M777.816,419.179a1.027,1.027,0,1,1,.981-.722,1.024,1.024,0,0,1-.981.722Zm0-1.351a.325.325,0,1,0,.1.015.322.322,0,0,0-.1-.015Z"
        transform="translate(-189.591 -417.068)"
        fill="#f0324c"
      />
      <path
        id="Path_800"
        data-name="Path 800"
        d="M976.637,39.048a1.027,1.027,0,1,1,.981-.722A1.024,1.024,0,0,1,976.637,39.048Zm0-1.351a.324.324,0,1,0,.1.015.324.324,0,0,0-.1-.015Zm.645.524h0Z"
        transform="translate(-374.432 -63.665)"
        fill="#f0324c"
      />
      <g id="Group_154" data-name="Group 154" transform="translate(579.328 -23.938)">
        <path
          id="Path_801"
          data-name="Path 801"
          d="M667.963,77.827H667.9v-.456h.061a.314.314,0,0,0,.258-.127.488.488,0,0,0,0-.591.312.312,0,0,0-.258-.128H667.9v-.3a.348.348,0,0,0-.11-.251.416.416,0,0,0-.567,0,.348.348,0,0,0-.11.251v.3h-.725l-.333-.5a.36.36,0,0,0-.321-.165.385.385,0,0,0-.283.11.345.345,0,0,0-.112.252v.3H665.2a.312.312,0,0,0-.258.128.488.488,0,0,0,0,.591.314.314,0,0,0,.258.127h.136v.456H665.2a.313.313,0,0,0-.258.128.489.489,0,0,0,0,.592.314.314,0,0,0,.258.127h.136v.3a.342.342,0,0,0,.112.25.385.385,0,0,0,.283.11.38.38,0,0,0,.283-.11.343.343,0,0,0,.11-.25v-.3h.724l.334.5a.367.367,0,0,0,.323.165.382.382,0,0,0,.283-.11.343.343,0,0,0,.11-.25v-.3h.061a.314.314,0,0,0,.258-.127.489.489,0,0,0,0-.592A.314.314,0,0,0,667.963,77.827Zm-1.836,0v-.233l.156.233Zm.987-.221-.157-.236h.157Z"
          transform="translate(-664.845 -75.862)"
          fill="#2f3042"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-8'
    },
    height: {
      type: String,
      default: 'h-6'
    }
  }
}
</script>
